module.exports = __webpack_public_path__ + "img/company_icon5.13602916.png";